import { FC } from 'react';
import { BusinessFormValues } from '..';
import { PercentageInput } from '../../UI';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';

interface BusinessOwnershipAllocationInputProps {
  className?: string;
}

export const BusinessOwnershipAllocationInput: FC<BusinessOwnershipAllocationInputProps> = ({ className }) => {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<BusinessFormValues>();
  const {
    field,
    formState: { errors },
  } = useController<BusinessFormValues, 'ownershipAllocation'>({
    control,
    name: 'ownershipAllocation',
    rules: { required: true },
    defaultValue: 100,
  });

  return (
    <PercentageInput
      {...field}
      decimalsLimit={3}
      allowNegativeValue={false}
      className={className}
      placeholder={tForm('general-required-placeholder')}
      label={tForm('business-ownership-allocation-input')}
      status={errors.ownershipAllocation ? 'errored' : 'normal'}
    />
  );
};
